import React from 'react';
import classnames from 'classnames';
import Icon from '../icon/index';
class Checkbox extends React.Component {
    constructor() {
        super(...arguments);
        this.handleChange = (e) => {
            const { onChange, disabled } = this.props;
            if (disabled)
                return;
            onChange && onChange(e);
        };
    }
    render() {
        const { children, disabled, size, checked, className } = this.props;
        const wrapCls = classnames('cfm_checkbox_wrapper', {
            'cfm_checkbox_disabled': disabled,
        }, className);
        const checkCls = classnames('cfm_checkbox', `cfm_checkbox_${size}`, {
            'cfm_checkbox_checked': checked,
        });
        return (<label className={wrapCls}>
        <span className={checkCls}>
          <input type='checkbox' checked={checked} onChange={this.handleChange} disabled={disabled} className='cfm_checkbox_input'/>
          <Icon className='cfm_checkbox_icon' size={size} type={checked ? 'check' : 'uncheck'}/>
        </span>{children}
      </label>);
    }
}
Checkbox.defaultProps = {
    checked: false,
    disabled: false,
    size: 'md',
};
export default Checkbox;



// WEBPACK FOOTER //
// ./components/checkbox/index.tsx